import Container from "@mui/material/Container";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";

interface ScreenProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  /** `lg` fits the article table; the editor stretches to `xl` for its two panes. */
  maxWidth?: "sm" | "md" | "lg" | "xl";
}

/** Shared page frame: consistent margins under the shell header. */
export function Screen({ children, sx, maxWidth = "lg" }: ScreenProps) {
  return (
    <Container
      maxWidth={maxWidth}
      sx={[
        {
          paddingInline: { xs: 2.5, md: 5 },
          paddingBlock: { xs: 3, md: 5 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Container>
  );
}
